import React, { useState } from "react";
import MediaLightbox from "./MediaLightbox";

const MEMBERS = [
  {
    name: "Domán László",
    role: "Dobok",
    image:
      "https://customer-assets.emergentagent.com/job_charge-charlie-band/artifacts/weemlrw1_dobos.webp",
    accent: "#FF007F",
  },
  {
    name: "Kupás Zoltán",
    role: "Basszusgitár",
    image:
      "https://customer-assets.emergentagent.com/job_charge-charlie-band/artifacts/bxerho8h_gitar1.webp",
    accent: "#7000FF",
  },
  {
    name: "Simkó János",
    role: "Ének",
    image:
      "https://customer-assets.emergentagent.com/job_charge-charlie-band/artifacts/sr5hov74_enekes.webp",
    accent: "#FF007F",
  },
  {
    name: "Sóvágó Zsolt",
    role: "Szólógitár",
    image:
      "https://customer-assets.emergentagent.com/job_charge-charlie-band/artifacts/vamrjp08_gitar2.webp",
    accent: "#00E5FF",
  },
  {
    name: "Varga Krisztián",
    role: "Billentyűs hangszerek",
    image:
      "https://customer-assets.emergentagent.com/job_charge-charlie-band/artifacts/0go35oft_Billentyu%282%29.png",
    accent: "#00E5FF",
  },
];

export const Members = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const lightboxItems = MEMBERS.map((m) => ({
    src: m.image,
    caption: m.name,
    subcaption: m.role,
  }));

  const openLightbox = (i) => {
    setLightboxIndex(i);
    setLightboxOpen(true);
  };

  return (
    <section
      id="tagok"
      className="relative w-full py-24 md:py-32 px-6 md:px-12 lg:px-20 bg-[#050505]"
      data-testid="members-section"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16">
          <div>
            <p className="font-display text-xs tracking-[0.4em] uppercase text-[#00E5FF] mb-6">
              // 02 — A csapat
            </p>
            <h2 className="font-display font-bold tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl">
              Tagok
            </h2>
          </div>
          <p className="font-body text-white/50 max-w-sm mt-6 md:mt-0 md:text-right">
            Öt tag, egy hangzás. Kattints egy kártyára a részletekért.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {MEMBERS.map((m, i) => (
            <article
              key={m.role}
              data-testid="member-card"
              className="member-card group relative overflow-hidden bg-[#0A0A0A] border border-white/10 hover:border-[var(--accent)]/60"
              style={{
                "--accent": m.accent,
                gridColumn:
                  i === 3 || i === 4
                    ? "auto"
                    : undefined,
              }}
            >
              <button
                type="button"
                onClick={() => openLightbox(i)}
                aria-label={`${m.name} képének megtekintése`}
                data-testid={`member-image-button-${i}`}
                className="block w-full text-left cursor-zoom-in"
              >
                <div className="relative aspect-[4/5] overflow-hidden bg-black">
                  <img
                    src={m.image}
                    alt={`${m.name} - ${m.role}`}
                    className="absolute inset-0 h-full w-full object-cover grayscale"
                    loading="lazy"
                  />
                  <div
                    className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/40 to-transparent"
                    aria-hidden="true"
                  />
                  <div
                    className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 mix-blend-overlay"
                    style={{
                      background: `linear-gradient(180deg, transparent 50%, ${m.accent}40 100%)`,
                    }}
                    aria-hidden="true"
                  />
                  {/* Number tag */}
                  <div className="absolute top-4 left-4 z-10">
                    <span
                      className="font-display text-xs tracking-[0.3em] uppercase px-2 py-1 border"
                      style={{
                        color: m.accent,
                        borderColor: `${m.accent}80`,
                        backgroundColor: "rgba(0,0,0,0.5)",
                      }}
                    >
                      0{i + 1}
                    </span>
                  </div>
                </div>
              </button>

              <div className="relative p-6 border-t border-white/10">
                <p
                  className="font-display text-[0.65rem] tracking-[0.3em] uppercase mb-2"
                  style={{ color: m.accent }}
                  data-testid="member-role"
                >
                  {m.role}
                </p>
                <h3
                  className="font-display text-2xl font-bold text-white tracking-tight"
                  data-testid="member-name"
                >
                  {m.name}
                </h3>
                <div
                  className="mt-4 h-px w-8 group-hover:w-16 transition-all duration-500"
                  style={{ backgroundColor: m.accent }}
                />
              </div>
            </article>
          ))}
        </div>
      </div>

      <MediaLightbox
        open={lightboxOpen}
        onOpenChange={setLightboxOpen}
        items={lightboxItems}
        index={lightboxIndex}
        setIndex={setLightboxIndex}
      />
    </section>
  );
};

export default Members;
